import { LightningElement, api, wire } from "lwc";
import { LabelsAdapter } from "common/labelsAdapter";
import { trackUserActivity } from "common/track";
import { getCollectionItem, createConfig } from "common/contentCollection";
import { AssignedLearningsFragment } from "@devforce/trailhead-client-gql";
import { gql } from "common/graphqlAdapter";
import { I18n, getLocale } from "@devforce/trailhead-client-locale";
import { getAssetsUrl } from "common/helpers";

var data$t = {
  errorHeading:
    "Oh! Beim Laden Ihrer Trails scheint ein Problem aufgetreten zu sein.",
  errorRefreshButtonLabel: "Aktualisieren",
  completedHeader: "Abgeschlossen",
  completedHeaderWithCounter: "Abgeschlossen (%{count})",
  resumeButtonLabel: "Weiter",
  showMoreLink: "Mehr anzeigen",
  trailPreTitle: "Trail",
  empty: {
    title:
      "Hier gibt es bisher nichts. Wenn Sie zugewiesene Lerninhalte in Trailhead abgeschlossen haben, werden diese hier aufgeführt.",
  },
};
data$t.errorHeading;
data$t.errorRefreshButtonLabel;
data$t.completedHeader;
data$t.completedHeaderWithCounter;
data$t.resumeButtonLabel;
data$t.showMoreLink;
data$t.trailPreTitle;
data$t.empty;

var data$s = {
  errorHeading: "Oh no, it looks like there was an error loading your Trails.",
  errorRefreshButtonLabel: "Refresh",
  completedHeader: "Completed",
  completedHeaderWithCounter: "Completed (%{count})",
  resumeButtonLabel: "Continue",
  showMoreLink: "Show More",
  trailPreTitle: "Trail",
  empty: {
    title:
      "Nothing here yet. Once you complete assigned learning on Trailhead, you'll see it here!",
  },
};
data$s.errorHeading;
data$s.errorRefreshButtonLabel;
data$s.completedHeader;
data$s.completedHeaderWithCounter;
data$s.resumeButtonLabel;
data$s.showMoreLink;
data$s.trailPreTitle;
data$s.empty;

var data$r = {
  errorHeading:
    "Vaya, parece que se ha producido un error al cargar las rutas.",
  errorRefreshButtonLabel: "Actualizar",
  completedHeader: "Completado",
  completedHeaderWithCounter: "Completado (%{count})",
  resumeButtonLabel: "Continuar",
  showMoreLink: "Mostrar más",
  trailPreTitle: "Ruta",
  empty: {
    title:
      "Todavía no hay nada aquí. Una vez completado el aprendizaje asignado en Trailhead, aparecerá aquí.",
  },
};
data$r.errorHeading;
data$r.errorRefreshButtonLabel;
data$r.completedHeader;
data$r.completedHeaderWithCounter;
data$r.resumeButtonLabel;
data$r.showMoreLink;
data$r.trailPreTitle;
data$r.empty;

var data$q = {
  errorHeading: "¡Vaya! Parece que ocurrió un error al cargar sus rutas.",
  errorRefreshButtonLabel: "Actualizar",
  completedHeader: "Completado",
  completedHeaderWithCounter: "Completado (%{count})",
  resumeButtonLabel: "Continuar",
  showMoreLink: "Mostrar más",
  trailPreTitle: "Ruta",
  empty: {
    title:
      "Nada por aquí. Una vez que complete el aprendizaje asignado en Trailhead, lo verá aquí.",
  },
};
data$q.errorHeading;
data$q.errorRefreshButtonLabel;
data$q.completedHeader;
data$q.completedHeaderWithCounter;
data$q.resumeButtonLabel;
data$q.showMoreLink;
data$q.trailPreTitle;
data$q.empty;

var data$p = {
  errorHeading: "Une erreur est survenue lors du chargement de vos parcours.",
  errorRefreshButtonLabel: "Actualiser",
  completedHeader: "Terminé",
  completedHeaderWithCounter: "Terminé (%{count})",
  resumeButtonLabel: "Continuer",
  showMoreLink: "Afficher plus",
  trailPreTitle: "Parcours",
  empty: {
    title:
      "Aucun élément disponible pour le moment. Une fois que vous aurez travaillé sur le contenu d’apprentissage attribué sur Trailhead, il apparaîtra ici !",
  },
};
data$p.errorHeading;
data$p.errorRefreshButtonLabel;
data$p.completedHeader;
data$p.completedHeaderWithCounter;
data$p.resumeButtonLabel;
data$p.showMoreLink;
data$p.trailPreTitle;
data$p.empty;

var data$o = {
  errorHeading:
    "Oh no! Si è verificato un errore durante il caricamento dei tuoi itinerari.",
  errorRefreshButtonLabel: "Aggiorna",
  completedHeader: "Completati",
  completedHeaderWithCounter: "Completati (%{count})",
  resumeButtonLabel: "Continua",
  showMoreLink: "Mostra altro",
  trailPreTitle: "Itinerario",
  empty: {
    title:
      "Qui non c’è ancora nulla. Le attività di formazione assegnate a te che hai completato saranno visualizzate qui.",
  },
};
data$o.errorHeading;
data$o.errorRefreshButtonLabel;
data$o.completedHeader;
data$o.completedHeaderWithCounter;
data$o.resumeButtonLabel;
data$o.showMoreLink;
data$o.trailPreTitle;
data$o.empty;

var data$n = {
  errorHeading: "トレイルの読み込み中にエラーが発生したようです。",
  errorRefreshButtonLabel: "更新",
  completedHeader: "完了",
  completedHeaderWithCounter: "完了 (%{count})",
  resumeButtonLabel: "続行",
  showMoreLink: "さらに表示",
  trailPreTitle: "トレイル",
  empty: {
    title:
      "まだ何もありません。Trailhead で割り当てられた学習を完了すると、ここに表示されます!",
  },
};
data$n.errorHeading;
data$n.errorRefreshButtonLabel;
data$n.completedHeader;
data$n.completedHeaderWithCounter;
data$n.resumeButtonLabel;
data$n.showMoreLink;
data$n.trailPreTitle;
data$n.empty;

var data$m = {
  errorHeading: "트레일을 로드하는 도중 오류가 발생한 것 같습니다.",
  errorRefreshButtonLabel: "새로고침",
  completedHeader: "완료됨",
  completedHeaderWithCounter: "완료됨(%{count})",
  resumeButtonLabel: "계속",
  showMoreLink: "더 보기",
  trailPreTitle: "트레일",
  empty: {
    title:
      "아직 아무것도 없습니다. 할당된 Trailhead 학습을 완료하면 여기에 표시됩니다.",
  },
};
data$m.errorHeading;
data$m.errorRefreshButtonLabel;
data$m.completedHeader;
data$m.completedHeaderWithCounter;
data$m.resumeButtonLabel;
data$m.showMoreLink;
data$m.trailPreTitle;
data$m.empty;

var data$l = {
  errorHeading: "Oh não! Parece que houve um erro ao carregar suas trilhas.",
  errorRefreshButtonLabel: "Atualizar",
  completedHeader: "Concluído",
  completedHeaderWithCounter: "Concluído (%{count})",
  resumeButtonLabel: "Continuar",
  showMoreLink: "Mostrar mais",
  trailPreTitle: "Trilha",
  empty: {
    title:
      "Ainda não há nada aqui. Após concluir a aprendizagem atribuída no Trailhead, você poderá visualizá-la aqui.",
  },
};
data$l.errorHeading;
data$l.errorRefreshButtonLabel;
data$l.completedHeader;
data$l.completedHeaderWithCounter;
data$l.resumeButtonLabel;
data$l.showMoreLink;
data$l.trailPreTitle;
data$l.empty;

var data$k = {
  errorHeading: "噢不，加载您的学习路径时似乎出现了错误。",
  errorRefreshButtonLabel: "刷新",
  completedHeader: "已完成",
  completedHeaderWithCounter: "已完成 (%{count})",
  resumeButtonLabel: "继续",
  showMoreLink: "显示更多",
  trailPreTitle: "学习路径",
  empty: {
    title:
      "此处尚无任何内容。您在 Trailhead 中完成分配的学习内容后，即可在此处看到！",
  },
};
data$k.errorHeading;
data$k.errorRefreshButtonLabel;
data$k.completedHeader;
data$k.completedHeaderWithCounter;
data$k.resumeButtonLabel;
data$k.showMoreLink;
data$k.trailPreTitle;
data$k.empty;

var locales$2 = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  de: data$t,
  en: data$s,
  es: data$r,
  esMX: data$q,
  fr: data$p,
  it: data$o,
  ja: data$n,
  ko: data$m,
  ptBR: data$l,
  zhCN: data$k,
});

var data$j = {
  durationMinute: "%{duration} Minute",
  durationMinutes: "%{duration} Minuten",
  durationHour: "%{duration} Stunde",
  durationHours: "%{duration} Stunden",
  todayTimestamp: "Heute, %{time}",
  yesterdayTimestamp: "Gestern, %{time}",
  lastActivity: "Zuletzt aktiv am %{date}",
};
data$j.durationMinute;
data$j.durationMinutes;
data$j.durationHour;
data$j.durationHours;
data$j.todayTimestamp;
data$j.yesterdayTimestamp;
data$j.lastActivity;

var data$i = {
  durationMinute: "%{duration} min",
  durationMinutes: "%{duration} mins",
  durationHour: "%{duration} hr",
  durationHours: "%{duration} hrs",
  todayTimestamp: "Today, %{time}",
  yesterdayTimestamp: "Yesterday, %{time}",
  lastActivity: "Last active on %{date}",
};
data$i.durationMinute;
data$i.durationMinutes;
data$i.durationHour;
data$i.durationHours;
data$i.todayTimestamp;
data$i.yesterdayTimestamp;
data$i.lastActivity;

var data$h = {
  durationMinute: "%{duration} minuto",
  durationMinutes: "%{duration} minutos",
  durationHour: "%{duration} hora",
  durationHours: "%{duration} horas",
  todayTimestamp: "Hoy, %{time}",
  yesterdayTimestamp: "Ayer, %{time}",
  lastActivity: "Última vez activo el %{date}",
};
data$h.durationMinute;
data$h.durationMinutes;
data$h.durationHour;
data$h.durationHours;
data$h.todayTimestamp;
data$h.yesterdayTimestamp;
data$h.lastActivity;

var data$g = {
  durationMinute: "%{duration} minuto",
  durationMinutes: "%{duration} minutos",
  durationHour: "%{duration} hora",
  durationHours: "%{duration} horas",
  todayTimestamp: "Hoy, %{time}",
  yesterdayTimestamp: "Ayer, %{time}",
  lastActivity: "Última actividad el %{date}",
};
data$g.durationMinute;
data$g.durationMinutes;
data$g.durationHour;
data$g.durationHours;
data$g.todayTimestamp;
data$g.yesterdayTimestamp;
data$g.lastActivity;

var data$f = {
  durationMinute: "%{duration} min",
  durationMinutes: "%{duration} min",
  durationHour: "%{duration} h",
  durationHours: "%{duration} h",
  todayTimestamp: "Aujourd’hui, à %{time}",
  yesterdayTimestamp: "Hier, à %{time}",
  lastActivity: "Dernière activité le %{date}",
};
data$f.durationMinute;
data$f.durationMinutes;
data$f.durationHour;
data$f.durationHours;
data$f.todayTimestamp;
data$f.yesterdayTimestamp;
data$f.lastActivity;

var data$e = {
  durationMinute: "%{duration} minunto",
  durationMinutes: "%{duration} minuti",
  durationHour: "%{duration} ora",
  durationHours: "%{duration} ore",
  todayTimestamp: "Oggi alle ore %{time}",
  yesterdayTimestamp: "Ieri alle ore %{time}",
  lastActivity: "Data dell'ultima attività: %{date}",
};
data$e.durationMinute;
data$e.durationMinutes;
data$e.durationHour;
data$e.durationHours;
data$e.todayTimestamp;
data$e.yesterdayTimestamp;
data$e.lastActivity;

var data$d = {
  durationMinute: "%{duration} 分",
  durationMinutes: "%{duration} 分",
  durationHour: "%{duration} 時間",
  durationHours: "%{duration} 時間",
  todayTimestamp: "今日、%{time}",
  yesterdayTimestamp: "昨日、%{time}",
  lastActivity: "最終活動日: %{date}",
};
data$d.durationMinute;
data$d.durationMinutes;
data$d.durationHour;
data$d.durationHours;
data$d.todayTimestamp;
data$d.yesterdayTimestamp;
data$d.lastActivity;

var data$c = {
  durationMinute: "%{duration}분",
  durationMinutes: "%{duration} 분",
  durationHour: "%{duration}시간",
  durationHours: "%{duration} 시간",
  todayTimestamp: "오늘, %{time}",
  yesterdayTimestamp: "어제, %{time}",
  lastActivity: "마지막 활동일: %{date}",
};
data$c.durationMinute;
data$c.durationMinutes;
data$c.durationHour;
data$c.durationHours;
data$c.todayTimestamp;
data$c.yesterdayTimestamp;
data$c.lastActivity;

var data$b = {
  durationMinute: "%{duration} min",
  durationMinutes: "%{duration} mins",
  durationHour: "%{duration} h",
  durationHours: "%{duration} h",
  todayTimestamp: "Hoje, %{time}",
  yesterdayTimestamp: "Ontem, %{time}",
  lastActivity: "Ativo pela última vez em %{date}",
};
data$b.durationMinute;
data$b.durationMinutes;
data$b.durationHour;
data$b.durationHours;
data$b.todayTimestamp;
data$b.yesterdayTimestamp;
data$b.lastActivity;

var data$a = {
  durationMinute: "%{duration} 分钟",
  durationMinutes: "%{duration} 分钟",
  durationHour: "%{duration} 小时",
  durationHours: "%{duration} 小时",
  todayTimestamp: "今天，%{time}",
  yesterdayTimestamp: "昨天，%{time}",
  lastActivity: "上次活跃时间 %{date}",
};
data$a.durationMinute;
data$a.durationMinutes;
data$a.durationHour;
data$a.durationHours;
data$a.todayTimestamp;
data$a.yesterdayTimestamp;
data$a.lastActivity;

var locales$1 = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  de: data$j,
  en: data$i,
  es: data$h,
  esMX: data$g,
  fr: data$f,
  it: data$e,
  ja: data$d,
  ko: data$c,
  ptBR: data$b,
  zhCN: data$a,
});

new I18n({
  helpers: locales$1,
});
function isOverdue(dueDate) {
  if (!dueDate) return false;

  // Get user's timezone
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // Get current time in user's timezone
  const now = new Date().toLocaleString("en-US", {
    timeZone: userTimeZone,
  });
  const nowDate = new Date(now);
  nowDate.setHours(0, 0, 0, 0);

  // Parse the due date and convert to user's timezone
  const dateOnly = dueDate.split("T")[0];
  const [year, month, day] = dateOnly.split("-").map(Number);
  const dueDateObj = new Date(year, month - 1, day);
  const dueDateInTz = new Date(
    dueDateObj.toLocaleString("en-US", {
      timeZone: userTimeZone,
    })
  );

  // Set to midnight of the next day (end of due date)
  const dueAtMidnight = new Date(dueDateInTz);
  dueAtMidnight.setHours(0, 0, 0, 0);
  dueAtMidnight.setDate(dueAtMidnight.getDate() + 1);
  return nowDate >= dueAtMidnight;
}

/**
 * Formats a date string with consistent short format (e.g., "Jan 15, 2024")
 * @param dateString ISO date string, date-only string (YYYY-MM-DD), or various other date formats
 * @returns Formatted date string, or original string if parsing fails
 */
function formatShortDate(dateString) {
  if (!dateString) return "";
  let dateObj;
  if (dateString.includes("-") && dateString.match(/^\d{4}-\d{1,2}-\d{1,2}$/)) {
    const dateOnly = dateString.split("T")[0];
    const [year, month, day] = dateOnly.split("-").map(Number);

    // Confirm this is a valid date before creating Date object
    if (month < 1 || month > 12 || day < 1 || day > 31) {
      return dateString;
    }
    dateObj = new Date(year, month - 1, day);

    // Confirm the created date matches input
    if (
      dateObj.getFullYear() !== year ||
      dateObj.getMonth() !== month - 1 ||
      dateObj.getDate() !== day
    ) {
      return dateString;
    }
  } else {
    // Fall back to native Date parsing for other formats
    dateObj = new Date(dateString);
  }

  // Check if date is valid
  if (isNaN(dateObj.getTime())) {
    // If parsing fails, return the original string
    return dateString;
  }
  const formatter = new Intl.DateTimeFormat(getLocale(), {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
  return formatter.format(dateObj);
}

var data$9 = {
  dueDateLabel: "Fällig am: %{formattedDueDate}",
  overdueLabel: "Überfällig: %{formattedDueDate}",
  assignedByLabel: "Zugewiesen von %{assignedBy}",
  salesforceLogoAltText: "Salesforce-Logo",
  employeetrail_pretitle: "Privater Trail",
};
data$9.dueDateLabel;
data$9.overdueLabel;
data$9.assignedByLabel;
data$9.salesforceLogoAltText;
data$9.employeetrail_pretitle;

var data$8 = {
  dueDateLabel: "Due: %{formattedDueDate}",
  overdueLabel: "Past Due: %{formattedDueDate}",
  assignedByLabel: "Assigned by %{assignedBy}",
  salesforceLogoAltText: "Salesforce Logo",
  employeetrail_pretitle: "Private Trail",
};
data$8.dueDateLabel;
data$8.overdueLabel;
data$8.assignedByLabel;
data$8.salesforceLogoAltText;
data$8.employeetrail_pretitle;

var data$7 = {
  dueDateLabel: "Vence el %{formattedDueDate}",
  overdueLabel: "Caducado desde el %{formattedDueDate}",
  assignedByLabel: "Asignado por %{assignedBy}",
  salesforceLogoAltText: "Logotipo de Salesforce",
  employeetrail_pretitle: "Ruta privada",
};
data$7.dueDateLabel;
data$7.overdueLabel;
data$7.assignedByLabel;
data$7.salesforceLogoAltText;
data$7.employeetrail_pretitle;

var data$6 = {
  dueDateLabel: "Vence el: %{formattedDueDate}",
  overdueLabel: "Atrasado: %{formattedDueDate}",
  assignedByLabel: "Asignado por %{assignedBy}",
  salesforceLogoAltText: "Logotipo de Salesforce",
  employeetrail_pretitle: "Ruta privada",
};
data$6.dueDateLabel;
data$6.overdueLabel;
data$6.assignedByLabel;
data$6.salesforceLogoAltText;
data$6.employeetrail_pretitle;

var data$5 = {
  dueDateLabel: "Échéance : %{formattedDueDate}",
  overdueLabel: "En retard : %{formattedDueDate}",
  assignedByLabel: "Attribué par %{assignedBy}",
  salesforceLogoAltText: "Logo Salesforce",
  employeetrail_pretitle: "Parcours privé",
};
data$5.dueDateLabel;
data$5.overdueLabel;
data$5.assignedByLabel;
data$5.salesforceLogoAltText;
data$5.employeetrail_pretitle;

var data$4 = {
  dueDateLabel: "Scadenza: %{formattedDueDate}",
  overdueLabel: "Scaduti: %{formattedDueDate}",
  assignedByLabel: "Assegnato da %{assignedBy}",
  salesforceLogoAltText: "Logo di Salesforce",
  employeetrail_pretitle: "Itinerario privato",
};
data$4.dueDateLabel;
data$4.overdueLabel;
data$4.assignedByLabel;
data$4.salesforceLogoAltText;
data$4.employeetrail_pretitle;

var data$3 = {
  dueDateLabel: "期日: %{formattedDueDate}",
  overdueLabel: "期日経過: %{formattedDueDate}",
  assignedByLabel: "割り当て者が %{assignedBy}",
  salesforceLogoAltText: "Salesforce のロゴ",
  employeetrail_pretitle: "非公開トレイル",
};
data$3.dueDateLabel;
data$3.overdueLabel;
data$3.assignedByLabel;
data$3.salesforceLogoAltText;
data$3.employeetrail_pretitle;

var data$2 = {
  dueDateLabel: "기한: %{formattedDueDate}",
  overdueLabel: "만기 경과: %{formattedDueDate}",
  assignedByLabel: "할당한 사람: %{assignedBy}",
  salesforceLogoAltText: "Salesforce 로고",
  employeetrail_pretitle: "비공개 트레일",
};
data$2.dueDateLabel;
data$2.overdueLabel;
data$2.assignedByLabel;
data$2.salesforceLogoAltText;
data$2.employeetrail_pretitle;

var data$1 = {
  dueDateLabel: "Data de vencimento: %{formattedDueDate}",
  overdueLabel: "Vencido a: %{formattedDueDate}",
  assignedByLabel: "Atribuído por %{assignedBy}",
  salesforceLogoAltText: "Logotipo do Salesforce",
  employeetrail_pretitle: "Trilha privada",
};
data$1.dueDateLabel;
data$1.overdueLabel;
data$1.assignedByLabel;
data$1.salesforceLogoAltText;
data$1.employeetrail_pretitle;

var data = {
  dueDateLabel: "到期：%{formattedDueDate}",
  overdueLabel: "过期：%{formattedDueDate}",
  assignedByLabel: "由 %{assignedBy} 分配",
  salesforceLogoAltText: "Salesforce 徽标",
  employeetrail_pretitle: "专用学习路径",
};
data.dueDateLabel;
data.overdueLabel;
data.assignedByLabel;
data.salesforceLogoAltText;
data.employeetrail_pretitle;

var locales = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  de: data$9,
  en: data$8,
  es: data$7,
  esMX: data$6,
  fr: data$5,
  it: data$4,
  ja: data$3,
  ko: data$2,
  ptBR: data$1,
  zhCN: data,
});

var salesforceLogo =
  "data:image/svg+xml,%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%3Cpath%20fill%3D%22%23E5E5E5%22%20d%3D%22M0%200h18v18H0z%22%2F%3E%3Cpath%20d%3D%22M-662-601a2%202%200%200%201%202-2h3116c1.1%200%202%20.895%202%202v3379c0%201.1-.9%202-2%202H-660c-1.104%200-2-.9-2-2V-601z%22%20fill%3D%22%23ADADAD%22%2F%3E%3Cpath%20d%3D%22M-660-602h3116v-2H-660v2zm3117%201v3379h2V-601h-2zm-1%203380H-660v2h3116v-2zm-3117-1V-601h-2v3379h2zm1%201c-.552%200-1-.45-1-1h-2c0%201.66%201.343%203%203%203v-2zm3117-1c0%20.55-.45%201-1%201v2c1.66%200%203-1.34%203-3h-2zm-1-3380c.55%200%201%20.448%201%201h2c0-1.657-1.34-3-3-3v2zm-3116-2a3%203%200%200%200-3%203h2a1%201%200%200%201%201-1v-2z%22%20fill%3D%22%23000%22%20fill-opacity%3D%22.1%22%2F%3E%3Cg%20clip-path%3D%22url%28%23a%29%22%3E%3Cpath%20fill%3D%22%23F3F3F3%22%20d%3D%22M-582-523H858v3223H-582z%22%2F%3E%3Cg%20filter%3D%22url%28%23b%29%22%3E%3Crect%20x%3D%22-20%22%20y%3D%22-227%22%20width%3D%22822%22%20height%3D%22328%22%20rx%3D%2212%22%20fill%3D%22%23fff%22%20shape-rendering%3D%22crispEdges%22%2F%3E%3Crect%20x%3D%22-19.5%22%20y%3D%22-226.5%22%20width%3D%22821%22%20height%3D%22327%22%20rx%3D%2211.5%22%20stroke%3D%22%23E5E5E5%22%20shape-rendering%3D%22crispEdges%22%2F%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20rx%3D%222%22%20fill%3D%22url%28%23c%29%22%2F%3E%3C%2Fg%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22a%22%3E%3Cpath%20fill%3D%22%23fff%22%20transform%3D%22translate%28-582%20-523%29%22%20d%3D%22M0%200h1440v3223H0z%22%2F%3E%3C%2FclipPath%3E%3Cpattern%20id%3D%22c%22%20patternContentUnits%3D%22objectBoundingBox%22%20width%3D%221%22%20height%3D%221%22%3E%3Cuse%20xlink%3Ahref%3D%22%23d%22%20transform%3D%22scale%28.01563%29%22%2F%3E%3C%2Fpattern%3E%3Cfilter%20id%3D%22b%22%20x%3D%22-24%22%20y%3D%22-230%22%20width%3D%22830%22%20height%3D%22336%22%20filterUnits%3D%22userSpaceOnUse%22%20color-interpolation-filters%3D%22sRGB%22%3E%3CfeFlood%20flood-opacity%3D%220%22%20result%3D%22BackgroundImageFix%22%2F%3E%3CfeColorMatrix%20in%3D%22SourceAlpha%22%20values%3D%220%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200%22%20result%3D%22hardAlpha%22%2F%3E%3CfeMorphology%20radius%3D%221%22%20operator%3D%22dilate%22%20in%3D%22SourceAlpha%22%20result%3D%22effect1_dropShadow_3_2%22%2F%3E%3CfeOffset%20dy%3D%221%22%2F%3E%3CfeGaussianBlur%20stdDeviation%3D%221.5%22%2F%3E%3CfeComposite%20in2%3D%22hardAlpha%22%20operator%3D%22out%22%2F%3E%3CfeColorMatrix%20values%3D%220%200%200%200%200.0941176%200%200%200%200%200.0941176%200%200%200%200%200.0941176%200%200%200%200.06%200%22%2F%3E%3CfeBlend%20in2%3D%22BackgroundImageFix%22%20result%3D%22effect1_dropShadow_3_2%22%2F%3E%3CfeBlend%20in%3D%22SourceGraphic%22%20in2%3D%22effect1_dropShadow_3_2%22%20result%3D%22shape%22%2F%3E%3C%2Ffilter%3E%3Cimage%20id%3D%22d%22%20width%3D%2264%22%20height%3D%2264%22%20preserveAspectRatio%3D%22none%22%20xlink%3Ahref%3D%22data%3Aimage%2Fpng%3Bbase64%2CiVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw%2FeHBhY2tldCBiZWdpbj0i77u%2FIiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8%2BIDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDkuMC1jMDAwIDc5LjE3MWMyN2ZhYiwgMjAyMi8wOC8xNi0yMjozNTo0MSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6ODhDNDc5N0E0ODA0MTFFREJGODRFMzE0NzlCM0ZEQkYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6ODhDNDc5Nzk0ODA0MTFFREJGODRFMzE0NzlCM0ZEQkYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIzLjUgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDowQzNEMjlGOTM5MkQxMUVEODRBM0I0QkJGNjM2MEQ0OCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowQzNEMjlGQTM5MkQxMUVEODRBM0I0QkJGNjM2MEQ0OCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI%2FPkdGzEcAAAKZSURBVHja7FuNdYIwEA7UARjBTlCcQJygOoEwQesE6gQ%2BJ5BMIJ1AnEA2MBuUDWxCQh%2F4QP4iIJd7L7XvSVLuu9x3d8lVu91uCLLoCLgoABQACgAFgAJAAQBYtEpPY2LQnzYdn3RYGU8EdPjsSbQcB8MBgCv%2BTce6wtoMCIcCQR6syUA06ZgmvjnTweZ4dG7YPQCYsBc80jGusT5TYEUVcTPA%2FKLDKJjvivlhNwBw5U8lXrRInAgETOb090PF9UIx32sXAEyYxS8SlE9a024MYotR4ChRedRQeRTtHEzsdnYA%2F0OHHpI2c4eJIM%2BpIFAzg3yDiExLuE0eANeapNc3YdFk%2B8h1tBziuwws38kNyVkcMB9gwmdFRuXGLQRgOtCs14hC%2Bh0I0GoBI4puPBkDWwwxct9BrwZtkeiBLofXeQCcAe0CIwsAD9AusPQcpoQi5ltGDXAEBECov0AB9NS8QBfKWwCVT%2BUBO6ixUBfHVCZQ%2Fc9sB3wCToaIPtDyt6x4OrC4n074luMQci2wh1wM%2BdT6PlQA%2BEVLIg8IgAGwQPy0%2BB8AH5Dyzr2%2BmjgZuQ493keWz7iy18VZuTtgf98idpuU068wEp8rxM%2FOx4OJ8fxkyy26WtcS5bCsq%2FA2rfsu3jc2XFC1lyB9NcZBOLxIcTSR0YaTzgP4gjPhN2GPLe%2FI6kF61CBhiELpI2NHWJ1lcLxlRlruotWahcmvZK4IBRHH3WfG3XeM1HCcvsqUUc15KyT3CG0v7vBbD8da7ZmYnCS5AmPuSVeE0qQYWkioI2LSRa8HAI%2B3swa1BFe%2BhWbI57hA2h02qFzjY0xqzOc3fYipmrSVivuI2U75KZOetgqA%2Bq8x4KIAUAAoABQACgAFgAIArvwJMAAOa7CDYqjyiAAAAABJRU5ErkJggg%3D%3D%22%2F%3E%3C%2Fdefs%3E%3C%2Fsvg%3E";

const i18n = new I18n({
  assignments: locales,
});
function generateDueDateHtml(assignment) {
  if (!assignment) return "";
  const isAssignmentOverdue = assignment.dueDate
    ? !assignment.completed && isOverdue(assignment.dueDate)
    : false;
  const formattedDueDate =
    (assignment.dueDate && formatShortDate(assignment.dueDate)) || "";
  const dueDateLabel = isAssignmentOverdue
    ? i18n.t("assignments", "overdueLabel", {
        formattedDueDate,
      })
    : i18n.t("assignments", "dueDateLabel", {
        formattedDueDate,
      });
  return `
    <div class="due-date">
      <tds-badge${
        isAssignmentOverdue ? " variant='badge-error'" : ""
      }>${dueDateLabel}</tds-badge>
    </div>
  `;
}
function generateAssignedByHtml(assignment) {
  if (!assignment) return "";
  const assignedByLabel = i18n.t("assignments", "assignedByLabel", {
    assignedBy: assignment.assignedBy,
  });
  return `
    <div class="assigned-by" style="display: flex; align-items: center; gap: var(--tds-spacing-2);">
      <img class="logo" alt="${i18n.t(
        "assignments",
        "salesforceLogoAltText"
      )}" src="${getAssetsUrl(salesforceLogo)}" />
      <span>${assignedByLabel}</span>
    </div>
  `;
}

/**
 * Normalizes user percentage complete - converts 0.0 to undefined to avoid showing 0% progress on trails that have not been started
 */
function normalizeUserPercentageComplete(user) {
  if (!user) return user;
  return user.percentageComplete === 0.0 &&
    (user.state === "NOT_STARTED" || !user.state)
    ? {
        ...user,
        percentageComplete: undefined,
      }
    : user;
}

/**
 * Appends a collection item with assignment-specific data (HTML content and assignment object)
 */
function appendAssignmentMetadata(item, assignment) {
  return {
    ...item,
    summary: {
      ...item.summary,
      user: normalizeUserPercentageComplete(item.summary.user),
      actionHtml: generateDueDateHtml(assignment),
      metaLeftHtml: generateAssignedByHtml(assignment),
      pretitle: i18n.t("assignments", "employeetrail_pretitle"),
      assignment,
    },
  };
}
function getAssignmentCollectionItems(result) {
  const edges = result.data.assignedLearnings.edges || [];
  return edges
    .map((edge) => edge?.node)
    .filter((node) => node != null)
    .map((assignedLearning, index) => {
      const collectionItem = getCollectionItem(assignedLearning.summary);
      const assignmentItem = appendAssignmentMetadata(
        collectionItem,
        assignedLearning.assignment
      );

      // Create a unique key by combining summary ID with index to prevent duplicate keys
      const uniqueKey = `${assignedLearning.summary.id}:${index}`;
      return {
        ...assignmentItem,
        summary: {
          ...assignmentItem.summary,
          id: uniqueKey, // Override the ID to be unique
        },
      };
    });
}

class Query {
  options = null;
  constructor(options) {
    this.options = options;
  }
  getQueryOptions(state) {
    return {
      query: gql`
        query CompletedAssignments($first: Int = 3, $after: String) {
          assignedLearnings(
            first: $first
            completionStatus: true
            after: $after
          ) {
            ...AssignedLearnings
          }
        }
        ${AssignedLearningsFragment}
      `,
      variables: {
        first: this.options.limit,
        after: state?.endCursor || null,
      },
    };
  }
  getCollectionItems(result) {
    return getAssignmentCollectionItems(result);
  }
  getTotalItemCount(result) {
    return result?.data.assignedLearnings.totalCount ?? undefined;
  }
  getState(result) {
    return {
      endCursor: result.data.assignedLearnings.pageInfo.endCursor,
    };
  }
  hasMore(result) {
    return result.data.assignedLearnings.pageInfo.hasNextPage;
  }
}

class CompletedLearningAssignments extends LightningElement {
  @api config = null;
  trail = null;
  enableViewAllLink = false;
  trailProgress = 0;
  completedCounter = 0;
  refreshKey = 0;
  resumeLink = "";
  loaded = false;
  hasErrorLoading = false;
  isHidden = true; // always hide the component (not stencil) unless there's data or an error

  @wire(LabelsAdapter, {
    locales: locales$2,
    options: "$labelOptions",
  })
  labels = {};
  get labelOptions() {
    return {
      completedHeaderWithCounter: {
        // This should be the number of results returned by the query
        count: this.completedCounter,
      },
    };
  }
  get configWithDefaults() {
    return createConfig(this.config, {
      card: {
        title: this.headerLabel,
        ctaLabel: this.labels.showMoreLink,
      },
      state: {
        empty: {
          title: this.labels["empty.title"],
        },
      },
    });
  }
  get query() {
    return new Query({
      limit: this.configWithDefaults.limit,
    });
  }
  handleStateChange(e) {
    this.dispatchEvent(
      new CustomEvent(e.type, {
        detail: e.detail,
      })
    );
  }
  handleCountChange(e) {
    this.completedCounter = e.detail;
  }
  get shouldRender() {
    return this.loaded && this.trail;
  }
  get isLoading() {
    return !this.loaded && !this.hasErrorLoading;
  }
  get headerLabel() {
    // Only use counter if it's been set, otherwise fallback to simple header
    return this.completedCounter > 0
      ? this.labels.completedHeaderWithCounter
      : this.labels.completedHeader;
  }
  handleRefresh() {
    this.hasErrorLoading = false;
    // Sets refreshKey to a unique string which, on change, retriggers the query
    this.refreshKey++;
  }
  track(event) {
    trackUserActivity(this, "cta_clicked", {
      ctaType: "secondary",
      label: `completed-learning-assignments-${event}`,
      pageLocation: "th-completed-learning-assignments",
    });
  }
}

export default CompletedLearningAssignments;
